import Vue from "vue";
import Vuex from "vuex";
import persistDataPlugin from "./persist-data";

Vue.use(Vuex);

const defaultClassified = {
	uniq_id: null,
	status: "draft",
	author: null,
	author_name: "",
	profil: null,
	category: null,
	mode: null,
	format: null,
	duration: null,
	start_date: null,
	end_date: null,
	membership: "0",
	title: "",
	content: "",
	// profession: null,
	profession_id: null,
	region: null,
	contact: "",
	medias: [],
	logo: null,
	option_background: false,
	option_move_top: false,
	option_domiciliation: false,
	option_urgent: false,
	option_diff_abcdent: false,
	option_diff_abcdent_pro: false,
	price: null,
	properties: [],

	available_dates: null,
	hours_available: null,
	salary: null,
	price: null,
	user_price: null,
	cities: [],
	cities_data: [],
	tags: [],
	partner_url: null,
	contracts: [],
	profil_email: "",
};

export default new Vuex.Store({
	state: {
		is_admin: false,
		is_dev: false,
		xhr: 0,
		townXhr: 0,
		settings: null,
		categories: [],
		step: 1,
		classified: {
			...defaultClassified,
		},
		preset: {},
		maxLength: 300,
		maxMedias: 1,
		remote_ts: null,
		allMedias: [],
		logoMedia: null,
	},
	mutations: {
		setSettings(state, settings) {
			state.settings = settings;
			state.settings.categories.forEach((group) => {
				group.categories.forEach((cat) => {
					state.categories.push(cat);
				});
			});
		},
		setStep(state, step) {
			state.step = step;
		},
		setIsAdmin(state, is_admin) {
			state.is_admin = is_admin;
		},
		setIsDev(state, is_dev) {
			state.is_dev = is_dev;
		},
		initClassified(state) {
			state.step = 1;
			state.classified = {
				...defaultClassified,
			};
			state.remote_ts = null;
			state.allMedias = [];
			state.logoMedia = null;
		},
		SET_CLASSIFIED(state, classified) {
			state.classified = Object.assign({}, state.classified, classified);
		},
		SET_PRESET(state, preset) {
			state.preset = preset;
		},
		setProfil(state, profil) {
			state.classified.profil = profil;
			state.classified.category = null;
			state.classified.mode = null;
			state.classified.format = null;
			state.classified.duration = null;
			state.classified.membership = "0";
			state.classified.option_move_top = false;
			state.classified.option_diff_abcdent = false;
			state.classified.option_diff_abcdent_pro = false;
		},
		setCategory(state, category) {
			state.classified.category = category;
			state.classified.mode = null;
			state.classified.contracts = [];
		},
		setAuthor(state, author) {
			state.classified.author = author;
		},
		setAuthorName(state, author_name) {
			state.classified.author_name = author_name;
		},
		setMode(state, mode) {
			state.classified.mode = mode;
			state.classified.format = null;
			state.classified.duration = null;
			state.classified.medias = [];

			if (
				mode == "print_web" ||
				state.categories.find(
					(cat) => cat.term_id == state.classified.category && cat.free_category
				)
			) {
				if (state.classified.profil === "recruiter") {
					state.classified.option_diff_abcdent = "1";
				} else {
					state.classified.option_diff_abcdent_pro = "1";
				}
			} else {
				state.classified.option_diff_abcdent = "";
				state.classified.option_diff_abcdent_pro = "";
			}

			state.classified.option_background = "";
			state.classified.option_domiciliation = "";
			state.classified.option_urgent = "";
		},
		setFormat(state, format) {
			state.classified.format = format;
		},
		setDuration(state, duration) {
			state.classified.duration = duration;
		},
		setStartDate(state, start_date) {
			state.classified.start_date = start_date;
		},
		setEndDate(state, end_date) {
			state.classified.end_date = end_date;
		},
		setMembership(state, membership) {
			state.classified.membership = parseInt(membership);
		},
		setTitle(state, title) {
			state.classified.title = title;
		},
		setStatus(state, status) {
			state.classified.status = status;
		},
		setContent(state, content) {
			state.classified.content = content.replace(/<p><\/p>/, "");
		},
		setProfession(state, profession) {
			state.classified.profession_id = profession;
		},
		setRegion(state, region) {
			state.classified.region = region;
		},
		setContact(state, contact) {
			state.classified.contact = contact;
		},
		setMedias(state, medias) {
			state.classified.medias = medias;
		},
		addMedia(state, media) {
			if (state.classified.medias == "") state.classified.medias = [];
			state.classified.medias.push(media);
		},
		removeMedia(state, media) {
			state.classified.medias = state.classified.medias.filter(
				(elt) => elt != media
			);
		},
		setAllMedias(state, medias) {
			medias.forEach((media) => state.allMedias.push(media));
		},
		addAllMedias(state, media) {
			state.allMedias.push(media);
		},
		setLogo(state, logo) {
			state.classified.logo = logo.attachment_id;
			state.logoMedia = logo;
		},
		setLogoMedia(state, logo) {
			state.logoMedia = logo;
		},
		removeLogo(state, logo) {
			state.classified.logo = null;
			state.logoMedia = null;
		},
		setOption(state, option) {
			state.classified[option.name] = option.value;
		},
		setMaxLength(state, length) {
			state.maxLength = length;
		},
		setMaxMedias(state, medias) {
			state.maxMedias = medias;
		},
		setRemote(state, ts) {
			state.remote_ts = ts;
		},
		FORCE_SAVE(state) {},
		startXhr(state) {
			state.xhr = state.xhr + 1;
		},
		endXhr(state) {
			state.xhr = state.xhr - 1;
		},
		updateTownXhr(state, v) {
			state.townXhr = v;
		},
		setCities(state, cities) {
			state.classified.cities = cities;
		},
		setKeywords(state, keywords) {
			state.classified.keywords = keywords;
		},
	},
	actions: {},
	modules: {},
	getters: {
		isAdmin: (state) => {
			return state.is_admin;
		},
		isDev: (state) => {
			return state.is_dev;
		},
		getSettings: (state) => {
			return state.settings;
		},
		getCategories: (state) => {
			return state.categories;
		},
		currentStep: (state) => {
			return state.step;
		},
		classified: (state) => {
			return state.classified;
		},
		getPreset: (state) => {
			return state.preset;
		},
		currentProfil: (state) => {
			return state.classified.profil;
		},
		currentCategory: (state) => {
			return state.classified.category;
		},
		isCurrentCategoryFree(state) {
			const c = state.categories.find(
				(cat) => cat.term_id == state.classified.category && cat.free_category
			);

			return Boolean(c);
		},
		isClassifiedFree(state) {
			const c = state.categories.find(
				(cat) => cat.term_id == state.classified.category && cat.free_category
			);

			return (
				Boolean(c) && state.classified.mode === "web" && !state.classified.price
			);
		},
		getCurrentCategory: (state) => {
			return state.categories.find(
				(category) => category.term_id === state.classified.category
			);
		},
		currentMode: (state) => {
			return state.classified.mode;
		},
		currentFormat: (state) => {
			return state.classified.format;
		},
		currentDuration: (state) => {
			return state.classified.duration;
		},
		currentMembership: (state) => {
			return state.classified.membership;
		},
		maxLength: (state) => {
			return state.maxLength;
		},
		maxMedias: (state) => {
			return state.maxMedias;
		},
		getMedia: (state) => (media_id) => {
			if (media_id == parseInt(state.classified.logo)) return state.logoMedia;
			return state.allMedias.find(
				(media) => parseInt(media.attachment_id) === media_id
			);
		},
		remoteTS: (state) => {
			return state.remote_ts;
		},
		getXhr: (state) => {
			return state.xhr;
		},
		getTownXhr: (state) => {
			return state.townXhr;
		},
	},
	plugins: [persistDataPlugin],
});
